<template>
  <div class="bus-pos">
    <div class="pos-plate" v-for="(bus, index) in allBus" :key="index" v-if="bus.seq * 1  === stationItem.seq * 1">
      <div  v-show="bus.status * 1 === 1" class="busWrap">
        <span class="busPlate">{{bus.busNum}}</span>
        <div><img class="bus-enter" src="../../../assets/image/minibus.png" /></div>
      </div>
      <div v-show="bus.status * 1 === 2" class="busWrap">
       <span class="busPlate">{{bus.busNum}}</span>
        <img class="bus-out"  src="../../../assets/image/minibus.png" />
      </div>
      <!-- <div v-if="bus.status ==2">
        <div class="bus-num" :class="{satationBus: bus.status == 2}" v-if="numArrTwo.length > 1">{{numArrTwo.length}}</div>
      </div>
      <div v-if="bus.status == 1">
        <div class="bus-num" :class="{satationBus: bus.status == 1}" v-if="numArr.length > 1">{{numArr.length}}</div>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      numArr: [],
      numArrTwo: [],
      // imgUrl:require('../../../assets/image/miniBus.png'),
    }
  },
  props: {
    allBus:{
      type: Array
    },
    stationItem: {
      type: Object
    }
  },
  watch: {
    allBus: {
      handler: function (val) {
        if (val) {
          this.numArr = []
          this.numArrTwo = []
          val.forEach(item => {
            if (item.seq * 1 === this.stationItem.seq * 1) {
              if (item.status * 1 === 1) {
                this.numArr.push(item.seq)
              } else {
                this.numArrTwo.push(item.seq)
              }
            }
          })
         
        }
      },
      immediate: true
    }
  },
  mounted(){
    
  }
}
</script>
<style scoped lang="scss">
$myWidth: 80px;
$basicColor: #2196F6;
.bus-pos {
  width: 100%;
  height: $myWidth;
  position: absolute;
  .busWrap{
      .busPlate{
        width:80px;
        position: absolute;
        left:14px;
        font-size: 13px;
        // bottom: 4px;
        color: #22B2ED;
      }
      .bus-enter {
        width: 25px;
        height: 13px;
        position: absolute;
        top:24px;
        // left:29px;
        left:-10px;
  }
    .bus-out {
        width: 25px;
        height: 13px;
        position: absolute;
        top: 24px;
        left:33px;
    }
  }
  
 
 
  .bus-num {
    width:10px;
    height:10px;
    border-radius: 50%;
    border: 1px solid #16b0a5;
    position: absolute;
    // top:6px;
    // left:35px;
    font-size: 14px;
    text-align: center;
    line-height: 10px;
    &.satationBus {
      // top: -10px;
      // left: 120px;
    }
  }
  .bus-number {
    position: absolute;
    top: -10px;
    left: 46px;
    font-size: 16px;
    color: #000000;
    &.satationBus {
      top: -10px;
      left: 103px;
    }
  }
}
</style>
